import { ProductType } from '../api/dbs/models';

export const getMarketingProductType = (product: {
  product_type: string;
  marketed_as_product_type?: string;
}) => (product.marketed_as_product_type || product.product_type) as ProductType;
